module.exports = __webpack_public_path__ + "static/meg-image-4e04ab650e3623a897ed3051d6ba36b3.jpg";